import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import {
    APP_INITIALIZER,
    ENVIRONMENT_INITIALIZER,
    EnvironmentProviders,
    Provider,
    inject,
    provideAppInitializer,
    provideEnvironmentInitializer,
} from '@angular/core';

import { CalsoftInterceptor } from '../../shared/utils/calsoft-interceptor';
import { AuthService } from './auth.service';


export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CalsoftInterceptor,
            multi: true,
        },
        provideEnvironmentInitializer(() => {
            inject(AuthService); 
        }),
     
    ];
};
